import { MenuItem, TextField } from '@mui/material'
import { CODICE_ADM_TIPOLOGIA, type TipologiaImpianto } from '@praticheenergia/domain'
import { tipologieDisponibili } from '../servizi/profilo'
import { ETICHETTA_TIPOLOGIA } from '../home/ripartizione'

interface Props {
  venditore: boolean
  valore: TipologiaImpianto
  onChange: (t: TipologiaImpianto) => void
}

export function SelettoreTipologia({ venditore, valore, onChange }: Props) {
  return (
    <TextField
      select
      fullWidth
      label="Tipologia di impianto"
      value={valore}
      onChange={(e) => onChange(e.target.value as TipologiaImpianto)}
    >
      {tipologieDisponibili(venditore).map((t) => {
        const codice = CODICE_ADM_TIPOLOGIA[t]
        return (
          <MenuItem key={t} value={t}>
            {ETICHETTA_TIPOLOGIA[t]}
            {codice ? ` — ${codice}` : ''}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
